import { render } from "./docs-layout.vue?vue&type=template&id=75fa38dd"
import script from "./docs-layout.vue?vue&type=script&lang=js"
export * from "./docs-layout.vue?vue&type=script&lang=js"

import "./docs-layout.vue?vue&type=style&index=0&id=75fa38dd&lang=css"

import exportComponent from "../../../accutrax-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__